import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading || user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-aimploy-bg">
                <div className="h-10 w-10 rounded-full border-2 border-aimploy-violet border-t-transparent animate-spin" />
            </div>
        );
    }
    if (!user) return <Navigate to="/admin/login" replace />;
    return children;
}
